'use client'

import useInitialiseUser from '@hooks/user/useInitialiseUser'

export default function InitialRenderFn(): null {
  useInitialiseUser()

  return null
}
